import { InputProvider } from "@context/Input/InputContext";
import { ReactNode } from "react";
import { AuthProvider } from "./auth";

export interface RootProviderProps {
  children: ReactNode;
}

export function RootProvider({ children }: RootProviderProps) {
  return (
    <AuthProvider>
      <InputProvider>{children}</InputProvider>
    </AuthProvider>
  );
}
